import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OrderAdminListQuery, OrderResult, OrdersPageResult } from './order.models';
import { orderStatuses } from './order-statuses';
import { BookingProductResult } from '../../../main/content/app/booking/booking.models';

@Injectable()
export class OrdersService {
    orderStatuses = orderStatuses;

    constructor(
        private http: HttpClient,
    ) {}

    get(id: string, status?: string) {
        return this.http.get<OrderResult>(`${environment.apiUrl}/orders/${id}`, {
            params: {
                status
            }
        });
    }

    setStatus(id: string, status: string) {
        return this.http.put<OrderResult>(`${environment.apiUrl}/orders/${id}/status`, {
            status
        });
    }

    list(
        status?: string,
        from?: Date,
        to?: Date,
        operator?: string,
        category?: string,
    ) {
        let params = new HttpParams();
        if (status && status.length) {
            params = params.set('status', status);
        }
        if (from) {
            params = params.set('from', from.toISOString());
        }
        if (to) {
            params = params.set('to', to.toISOString());
        }
        if (operator && operator.length) {
            params = params.set('operator', operator);
        }
        if (category && category.length) {
            params = params.set('category', category);
        }
        return this.http.get<OrderResult[]>(`${environment.apiUrl}/orders`, {params});
    }

    listAdminPage(query: OrderAdminListQuery = {}) {
        let params = new HttpParams();

        if (query.status && query.status.length) {
            params = params.set('status', query.status);
        }
        if (query.from) {
            params = params.set('from', query.from.toISOString());
        }
        if (query.to) {
            params = params.set('to', query.to.toISOString());
        }
        if (query.operator && query.operator.length) {
            params = params.set('operator', query.operator);
        }
        if (query.category && query.category.length) {
            params = params.set('category', query.category);
        }
        if (typeof query.page === 'number') {
            params = params.set('page', query.page.toString());
        }
        if (typeof query.limit === 'number') {
            params = params.set('limit', query.limit.toString());
        }
        if (query.search && query.search.length) {
            params = params.set('search', query.search);
        }
        if (query.sortBy && query.sortBy.length) {
            params = params.set('sortBy', query.sortBy);
        }
        if (query.sortDirection && query.sortDirection.length) {
            params = params.set('sortDirection', query.sortDirection);
        }

        return this.http.get<OrdersPageResult>(`${environment.apiUrl}/orders/admin/list`, { params });
    }

    getStatusClass(val: string) {
        const res = this.orderStatuses.find(el => el.name === val);
        if (res) {
            return res.color;
        }
        return '';
    }

    refund(id: string) {
        return this.http.put<any>(`${environment.apiUrl}/orders/${id}/refund`, {});
    }

    resendEmail(id: string) {
        return this.http.put<any>(`${environment.apiUrl}/orders/${id}/resendMail`, {});
    }

    sendPaymentLink(id: string) {
        return this.http.put<any>(`${environment.apiUrl}/orders/${id}/sendPaymentLink`, {});
    }

    sendPaymentReminder(id: string) {
        return this.http.put<any>(`${environment.apiUrl}/orders/${id}/sendPaymentReminder`, {});
    }

    save(order: OrderResult) {
        return this.http.put<OrderResult>(`${environment.apiUrl}/orders/${order._id}`, {
            comment: order.comment,
            direction: order.direction,
            discount: order.discount || false,
            items: order.items,
        });
    }

    getProduct(id: string, date: Date) {
        if (typeof date === 'string') {
            date = new Date(date);
        }
        const params = new HttpParams().set('date', date.toISOString());
        return this.http.get<BookingProductResult>(`${environment.apiUrl}/booking/product/${id}`, {params});
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/core/services/orders/orders.service.ts